import moment from 'moment';
import 'moment/locale/es';
import { MONTHS } from '../components/utils/lists';
import { format } from 'date-fns';

export const getMonthName = (dateString) => {
	const date = moment(dateString);
	const monthName = date.format('MMMM'); // Get month name in Spanish
	return monthName.charAt(0).toUpperCase() + monthName.slice(1);
};

// Get today date in gringo format using moment
export const getTodayDateMoment = (addedDays = 0, format = null) =>
	moment()
		.add(addedDays, 'days')
		.format(format ? format : 'YYYY-MM-DD');

// Get today date in gringo format
export const getTodayDate = (addedDays = 0, start = false) => {
	// moment().add(addedDays, 'days').format('YYYY-MM-DD');
	const today = new Date();
	let adjustedDate = null;
	adjustedDate = start
		? setTime(new Date(today), 0, 0, 0)
		: setTime(new Date(today), 23, 59, 59);
	adjustedDate.setDate(today.getDate() + addedDays);

	return adjustedDate;
};

// Get today datetime
export const getTodayDateTime = () => moment().format('DD/MM/YYYY HH:mm');

// Convert YYYY-MM-DD --> MM/DD/YYYY
export const gringoFormat = (date) =>
	date ? moment(date).format('MM/DD/YYYY') : '-';

// Convert YYYY-MM-DD --> DD/MM/YYYY
export const localDateFormat = (date) =>
	date ? moment(date).format('DD/MM/YYYY') : '-';

// Replace slash for dash
export const replaceSlashForDash = (date) =>
	date.replace('/', '-').replace('/', '-');

// Replace dash for slash
export const replaceDashForSlash = (date) =>
	date.replace('-', '/').replace('-', '/');

export const getFormattedMonth = (monthOffset = 0) => {
	// Get the current date
	const currentDate = new Date();

	// Add the specified month offset
	currentDate.setMonth(currentDate.getMonth() + monthOffset);

	// Define an array of month names in Spanish
	const monthNames = [
		'enero',
		'febrero',
		'marzo',
		'abril',
		'mayo',
		'junio',
		'julio',
		'agosto',
		'septiembre',
		'octubre',
		'noviembre',
		'diciembre',
	];

	// Get the month index and use it to get the corresponding month name
	const monthIndex = currentDate.getMonth();
	const formattedMonth = monthNames[monthIndex];

	// Return the formatted month
	return formattedMonth;
};

// Fill date with zeros
export const fillDateWithZeros = (date) => {
	date = replaceDashForSlash(date).split('/');
	date.forEach((item, i) => {
		if (item.length < 2) date[i] = '0' + item;
	});
	return date.join('/');
};

// Convert timestamp obj to normal date
export const timestampToNormalDate = (date) => {
	if (date) {
		date = new Date(date.seconds * 1000).toLocaleDateString('mx');
		return fillDateWithZeros(date);
	}
	return null;
};

// Convert timestamp obj to normal datetime
export const timestampToNormalDateTime = (date) => {
	if (date) {
		date = new Date((date?.seconds ? date.seconds : date?._seconds) * 1000);
		return moment(date, 'MM/DD/YYYY').format('DD/MM/YYYY HH:mm:ss');
	}
	return null;
};

// 2022-10-28 --> 28/10/2022
export const formatDateMX = (date) => {
	if (!date || date === 'No definido') return '-';
	let newDate = null;
	if (date.includes('T')) {
		newDate = date?.split('T')[0]?.split('-');
	} else {
		newDate = date?.split('-');
	}

	// In case the date is already formatted
	if (
		date?.length === 10 &&
		date.charAt(2) === '/' &&
		date.charAt(5) === '/'
	) {
		return date;
	}
	return `${newDate[2]}/${newDate[1]}/${newDate[0]}`;
};

// 2022-10-28 --> 10/28/2022
export const formatDateUSA = (date) => {
	if (!date) return false;
	const newDate = date?.split('T')[0]?.split('-');
	return `${newDate[1]}/${newDate[2]}/${newDate[0]}`;
};

// 2022-10-28T12:31:02 --> 2022-10-28
export const getJustDateUSAFormat = (date) => {
	if (!date) return null;
	return date?.split('T')[0];
};

// 2022-10-28T12:31:02 --> 28/10/2022 - 12:31:02
export const formatDateTimeMX = (date) => {
	if (!date) return false;
	const datetime = date?.split('T');
	const newDate = datetime[0]?.split('-');
	const time = datetime[1]?.split('.')[0];
	return `${newDate[2]}/${newDate[1]}/${newDate[0]} - ${time}`;
};

// Format date DD/MM/YYYY
export const formatDate = (date, type = 0) => {
	if ((typeof date === 'string' && date.length > 0) || type === 1) {
		try {
			return fillDateWithZeros(date.toLocaleDateString('mx'));
		} catch (error) {
			return date;
		}
	} else if (typeof date === 'object') {
		return timestampToNormalDate(date);
	}
	return false;
};

// Get current month
export const getCurrentMonth = () => {
	const currentMonthNumber = new Date().getMonth() + 1;
	// Get the month number
	return MONTHS.find(({ number }) => number === currentMonthNumber).name;
};

// Format to normak date from date field picker
export const format2Date = (date, format = 'YYYY-MM-DD') =>
	date ? moment(date).format(format) : null;

// Sort array by timestamp
export const sortByTimestamp = (array) =>
	array.sort((a, b) => b.created.seconds - a.created.seconds);

// Add days to date
export const addDaysToDaye = (date, n) =>
	moment(date, 'DD/MM/YYYY').add(parseInt(n), 'days').format('DD/MM/YYYY');

// Substract days to date
export const substractDaysToDaye = (date, n) =>
	moment(date, 'DD/MM/YYYY')
		.subtract(parseInt(n), 'days')
		.format('DD/MM/YYYY');

// Get difference between days
export const diffDays = (date1, date2) => {
	if (date1 && date2) {
		date1 = moment(date1, 'DD/MM/YYYY');
		date2 = moment(date2, 'DD/MM/YYYY');
		return date2.diff(date1, 'days');
	}
	return 0;
};

// Set hours, minutes and seconds to a JS Date data type
export const setTime = (date, h, m, s) => {
	let newDate = date;
	newDate.setHours(h);
	newDate.setMinutes(m);
	newDate.setSeconds(s);
	return newDate;
};

// Calculate differente between two dates
export const calculateTimeDifference = (
	timestamp1,
	timestamp2,
	measurement = 'minutes'
) => {
	// Convert both timestamps to milliseconds
	const time1InMs =
		timestamp1._seconds * 1000 + timestamp1._nanoseconds / 1000000;
	const time2InMs =
		timestamp2._seconds * 1000 + timestamp2._nanoseconds / 1000000;

	// Create moment objects from the milliseconds
	const momentTime1 = moment(time1InMs);
	const momentTime2 = moment(time2InMs);

	// Calculate the difference in various units
	const millisecondsDifference = Math.abs(
		momentTime1.diff(momentTime2, 'milliseconds')
	);
	const secondsDifference = Math.abs(
		momentTime1.diff(momentTime2, 'seconds')
	);
	const minutesDifference = Math.abs(
		momentTime1.diff(momentTime2, 'minutes')
	);
	const hoursDifference = Math.abs(momentTime1.diff(momentTime2, 'hours'));
	const daysDifference = Math.abs(momentTime1.diff(momentTime2, 'days'));

	const mesuarementValues = {
		milliseconds: millisecondsDifference,
		seconds: secondsDifference,
		minutes: minutesDifference,
		hours: hoursDifference,
		days: daysDifference,
	};

	return mesuarementValues[measurement];
};

export const formatDateForm = (date, formatPattern = 'dd/MM/yyyy') => {
	if (!date) return null;

	const dateObj = typeof date === 'string' ? new Date(date) : date;

	return format(dateObj, formatPattern);
};
